// client/src/components/BookingConfirmationModal.js

import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

// Helper to format the date/time
const formatDateTime = (isoDate, timeString) => {
    const date = new Date(`${isoDate} ${timeString}`);
    return date.toLocaleString('en-US', { 
        weekday: 'long', month: 'long', day: 'numeric', 
        hour: 'numeric', minute: '2-digit', hour12: true 
    });
};

const BookingConfirmationModal = ({ show, onHide, onConfirm, bookingDetails, isLoading, progressMessage, filters }) => {
  if (!bookingDetails || !filters) {
    return null;
  }

  // ✅ Logic to extract the correct prices based on the user's filters
  const priceKey = filters.holes === 9 ? '9_holes' : '18_holes';
  const walkingPrice = bookingDetails.time.price?.[priceKey]?.walking || 0;
  const ridingPrice = bookingDetails.time.price?.[priceKey]?.riding || 0;
  
  // Calculate total price based on walking, as it's the default
  const totalPrice = (walkingPrice * bookingDetails.golfers).toFixed(2);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Your Booking</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Please review and confirm your tee time details.</p>
        <div className="bg-light p-3 rounded">
            <h5>{bookingDetails.course.name}</h5>
            <p className="mb-0">
                <strong>Time:</strong> {formatDateTime(bookingDetails.date, bookingDetails.time.time)}
            </p>
            <p className="mb-0">
                <strong>Players:</strong> {bookingDetails.golfers}
            </p>
            <hr className="my-2" />
            {/* ✅ New Price Details Section */}
            <p className="mb-0">
                <strong>Price per Golfer:</strong>
            </p>
            <ul className="list-unstyled ms-3">
                <li>${walkingPrice.toFixed(2)} (Walking)</li>
                <li>${ridingPrice.toFixed(2)} (With Cart)</li>
            </ul>
            <p className="mb-0 fw-bold">
                Total (Walking): ${totalPrice}
            </p>
        </div>

        {isLoading && (
          <div className="text-center mt-3">
            <Spinner animation="border" variant="primary" />
            <p className="text-muted fst-italic mt-2 mb-0">{progressMessage}</p>
          </div>
        )}

      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? 'Booking...' : `Confirm & Book`}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BookingConfirmationModal;